import type { Currency } from '@/sdk'
import { ChainId, Token } from '@/sdk'

/** Tokens cuyo saldo consulta la billetera: listas estáticas + catálogo visible + usuario. */
export function mergePortfolioTrackedTokens(
  chainId: ChainId,
  allTokens: { [address: string]: Token },
  catalogTokens: Currency[],
): Token[] {
  const byAddress = new Map<string, Token>()

  for (const token of Object.values(allTokens)) {
    if (token.chainId === chainId) {
      byAddress.set(token.address.toLowerCase(), token)
    }
  }

  for (const currency of catalogTokens) {
    if (currency instanceof Token && currency.chainId === chainId) {
      const key = currency.address.toLowerCase()
      if (!byAddress.has(key)) {
        byAddress.set(key, currency)
      }
    }
  }

  return [...byAddress.values()]
}
